// src/components/RemediationNoteModal.jsx
import { useState } from 'react';

export default function RemediationNoteModal({ open, onClose, onSave, fieldLabel }) {
  const [noteText, setNoteText] = useState('');

  const handleSave = () => {
    if (!noteText.trim()) {
      alert('Please enter a note');
      return;
    }
    onSave(noteText.trim());
    setNoteText('');
    onClose();
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 p-6">
        <h2 className="text-xl font-bold mb-4">Add Remediation Note</h2>
        
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Field: <span className="font-semibold">{fieldLabel}</span>
          </label>
          
          <textarea
            value={noteText}
            onChange={(e) => setNoteText(e.target.value)}
            placeholder="Describe the issue, correction, or additional context..."
            className="w-full border border-gray-300 rounded p-3 text-sm min-h-[120px]"
            autoFocus
          />
          
          <div className="text-xs text-gray-500 mt-1">
            This note will be permanently attached to this field with your name and timestamp.
          </div>
        </div>

        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="px-4 py-2 bg-yellow-600 text-white rounded hover:bg-yellow-700"
          >
            💾 Save Note
          </button>
        </div>
      </div>
    </div>
  );
}
